import Highcharts from 'highcharts/highstock';
import HighchartsReact from 'highcharts-react-official';
import DraggablePoints from 'highcharts/modules/draggable-points';
import Navigator from 'highcharts/modules/navigator';
import { useEffect } from 'react';

// Import highcharts modules
DraggablePoints(Highcharts);
Navigator(Highcharts);

// Line and Columns Data
// const LINE_CHART_DATA_ORIGINAL = [
//     [
//         1714521600000,
//         266
//     ],
//     [
//         1714608000000,
//         177
//     ],
//     [
//         1714694400000,
//         311
//     ],
//     [
//         1714780800000,
//         312
//     ],
//     [
//         1714867200000,
//         409
//     ],
//     [
//         1714953600000,
//         440
//     ],
//     [
//         1715040000000,
//         305
//     ],
//     [
//         1715126400000,
//         317
//     ],
//     [
//         1715212800000,
//         453
//     ],
//     [
//         1715299200000,
//         433
//     ],
//     [
//         1715385600000,
//         229
//     ],
//     [
//         1715472000000,
//         212
//     ],
//     [
//         1715558400000,
//         420
//     ],
//     [
//         1715644800000,
//         154
//     ],
//     [
//         1715731200000,
//         123
//     ],
//     [
//         1715817600000,
//         370
//     ],
//     [
//         1715904000000,
//         351
//     ],
//     [
//         1715990400000,
//         290
//     ],
//     [
//         1716076800000,
//         465
//     ],
//     [
//         1716163200000,
//         275
//     ],
//     [
//         1716249600000,
//         245
//     ],
//     [
//         1716336000000,
//         285
//     ],
//     [
//         1716422400000,
//         320
//     ],
//     [
//         1716508800000,
//         426
//     ],
//     [
//         1716595200000,
//         492
//     ],
//     [
//         1716681600000,
//         295
//     ],
//     [
//         1716768000000,
//         483
//     ],
//     [
//         1716854400000,
//         348
//     ],
//     [
//         1716940800000,
//         459
//     ],
//     [
//         1717027200000,
//         388
//     ],
//     [
//         1717113600000,
//         219
//     ],
//     [
//         1717200000000,
//         456
//     ],
//     [
//         1717286400000,
//         235
//     ],
//     [
//         1717372800000,
//         257
//     ],
//     [
//         1717459200000,
//         220
//     ],
//     [
//         1717545600000,
//         167
//     ],
//     [
//         1717632000000,
//         493
//     ],
//     [
//         1717718400000,
//         337
//     ],
//     [
//         1717804800000,
//         339
//     ],
//     [
//         1717891200000,
//         277
//     ],
//     [
//         1717977600000,
//         415
//     ],
//     [
//         1718064000000,
//         472
//     ],
//     [
//         1718150400000,
//         495
//     ],
//     [
//         1718236800000,
//         133
//     ],
//     [
//         1718323200000,
//         167
//     ],
//     [
//         1718409600000,
//         105
//     ],
//     [
//         1718496000000,
//         108
//     ],
//     [
//         1718582400000,
//         408
//     ],
//     [
//         1718668800000,
//         342
//     ],
//     [
//         1718755200000,
//         313
//     ],
//     [
//         1718841600000,
//         466
//     ],
//     [
//         1718928000000,
//         190
//     ],
//     [
//         1719014400000,
//         187
//     ],
//     [
//         1719100800000,
//         369
//     ],
//     [
//         1719187200000,
//         323
//     ],
//     [
//         1719273600000,
//         330
//     ],
//     [
//         1719360000000,
//         134
//     ],
//     [
//         1719446400000,
//         432
//     ],
//     [
//         1719532800000,
//         490
//     ],
//     [
//         1719619200000,
//         143
//     ],
//     [
//         1719705600000,
//         134
//     ],
//     [
//         1719792000000,
//         427
//     ],
//     [
//         1719878400000,
//         274
//     ],
//     [
//         1719964800000,
//         415
//     ],
//     [
//         1720051200000,
//         458
//     ],
//     [
//         1720137600000,
//         118
//     ],
//     [
//         1720224000000,
//         292
//     ],
//     [
//         1720310400000,
//         375
//     ],
//     [
//         1720396800000,
//         297
//     ],
//     [
//         1720483200000,
//         439
//     ],
//     [
//         1720569600000,
//         389
//     ],
//     [
//         1720656000000,
//         127
//     ],
//     [
//         1720742400000,
//         187
//     ],
//     [
//         1720828800000,
//         500
//     ],
//     [
//         1720915200000,
//         404
//     ],
//     [
//         1721001600000,
//         349
//     ],
//     [
//         1721088000000,
//         449
//     ],
//     [
//         1721174400000,
//         118
//     ],
//     [
//         1721260800000,
//         449
//     ],
//     [
//         1721347200000,
//         330
//     ],
//     [
//         1721433600000,
//         373
//     ],
//     [
//         1721520000000,
//         454
//     ],
//     [
//         1721606400000,
//         212
//     ],
//     [
//         1721692800000,
//         151
//     ],
//     [
//         1721779200000,
//         294
//     ],
//     [
//         1721865600000,
//         494
//     ],
//     [
//         1721952000000,
//         321
//     ],
//     [
//         1722038400000,
//         337
//     ],
//     [
//         1722124800000,
//         346
//     ],
//     [
//         1722211200000,
//         281
//     ],
//     [
//         1722297600000,
//         105
//     ],
//     [
//         1722384000000,
//         457
//     ]
// ]
// let LINE_CHART_DATA = [
//     [
//         1714521600000,
//         266
//     ],
//     [
//         1714608000000,
//         177
//     ],
//     [
//         1714694400000,
//         311
//     ],
//     [
//         1714780800000,
//         312
//     ],
//     [
//         1714867200000,
//         409
//     ],
//     [
//         1714953600000,
//         440
//     ],
//     [
//         1715040000000,
//         305
//     ],
//     [
//         1715126400000,
//         317
//     ],
//     [
//         1715212800000,
//         453
//     ],
//     [
//         1715299200000,
//         433
//     ],
//     [
//         1715385600000,
//         229
//     ],
//     [
//         1715472000000,
//         212
//     ],
//     [
//         1715558400000,
//         420
//     ],
//     [
//         1715644800000,
//         154
//     ],
//     [
//         1715731200000,
//         123
//     ],
//     [
//         1715817600000,
//         370
//     ],
//     [
//         1715904000000,
//         351
//     ],
//     [
//         1715990400000,
//         290
//     ],
//     [
//         1716076800000,
//         465
//     ],
//     [
//         1716163200000,
//         275
//     ],
//     [
//         1716249600000,
//         245
//     ],
//     [
//         1716336000000,
//         285
//     ],
//     [
//         1716422400000,
//         320
//     ],
//     [
//         1716508800000,
//         426
//     ],
//     [
//         1716595200000,
//         492
//     ],
//     [
//         1716681600000,
//         295
//     ],
//     [
//         1716768000000,
//         483
//     ],
//     [
//         1716854400000,
//         348
//     ],
//     [
//         1716940800000,
//         459
//     ],
//     [
//         1717027200000,
//         388
//     ],
//     [
//         1717113600000,
//         219
//     ],
//     [
//         1717200000000,
//         456
//     ],
//     [
//         1717286400000,
//         235
//     ],
//     [
//         1717372800000,
//         257
//     ],
//     [
//         1717459200000,
//         220
//     ],
//     [
//         1717545600000,
//         167
//     ],
//     [
//         1717632000000,
//         493
//     ],
//     [
//         1717718400000,
//         337
//     ],
//     [
//         1717804800000,
//         339
//     ],
//     [
//         1717891200000,
//         277
//     ],
//     [
//         1717977600000,
//         415
//     ],
//     [
//         1718064000000,
//         472
//     ],
//     [
//         1718150400000,
//         495
//     ],
//     [
//         1718236800000,
//         133
//     ],
//     [
//         1718323200000,
//         167
//     ],
//     [
//         1718409600000,
//         105
//     ],
//     [
//         1718496000000,
//         108
//     ],
//     [
//         1718582400000,
//         408
//     ],
//     [
//         1718668800000,
//         342
//     ],
//     [
//         1718755200000,
//         313
//     ],
//     [
//         1718841600000,
//         466
//     ],
//     [
//         1718928000000,
//         190
//     ],
//     [
//         1719014400000,
//         187
//     ],
//     [
//         1719100800000,
//         369
//     ],
//     [
//         1719187200000,
//         323
//     ],
//     [
//         1719273600000,
//         330
//     ],
//     [
//         1719360000000,
//         134
//     ],
//     [
//         1719446400000,
//         432
//     ],
//     [
//         1719532800000,
//         490
//     ],
//     [
//         1719619200000,
//         143
//     ],
//     [
//         1719705600000,
//         134
//     ],
//     [
//         1719792000000,
//         427
//     ],
//     [
//         1719878400000,
//         274
//     ],
//     [
//         1719964800000,
//         415
//     ],
//     [
//         1720051200000,
//         458
//     ],
//     [
//         1720137600000,
//         118
//     ],
//     [
//         1720224000000,
//         292
//     ],
//     [
//         1720310400000,
//         375
//     ],
//     [
//         1720396800000,
//         297
//     ],
//     [
//         1720483200000,
//         439
//     ],
//     [
//         1720569600000,
//         389
//     ],
//     [
//         1720656000000,
//         127
//     ],
//     [
//         1720742400000,
//         187
//     ],
//     [
//         1720828800000,
//         500
//     ],
//     [
//         1720915200000,
//         404
//     ],
//     [
//         1721001600000,
//         349
//     ],
//     [
//         1721088000000,
//         449
//     ],
//     [
//         1721174400000,
//         118
//     ],
//     [
//         1721260800000,
//         449
//     ],
//     [
//         1721347200000,
//         330
//     ],
//     [
//         1721433600000,
//         373
//     ],
//     [
//         1721520000000,
//         454
//     ],
//     [
//         1721606400000,
//         212
//     ],
//     [
//         1721692800000,
//         151
//     ],
//     [
//         1721779200000,
//         294
//     ],
//     [
//         1721865600000,
//         494
//     ],
//     [
//         1721952000000,
//         321
//     ],
//     [
//         1722038400000,
//         337
//     ],
//     [
//         1722124800000,
//         346
//     ],
//     [
//         1722211200000,
//         281
//     ],
//     [
//         1722297600000,
//         105
//     ],
//     [
//         1722384000000,
//         457
//     ]
// ]

const LINE_CHART_DATA_ORIGINAL = [
    [
        1722470400000,
        225
    ],
    [
        1722556800000,
        389
    ],
    [
        1722643200000,
        287
    ],
    [
        1722729600000,
        128
    ],
    [
        1722816000000,
        178
    ],
    [
        1722902400000,
        227
    ],
    [
        1722988800000,
        119
    ],
    [
        1723075200000,
        140
    ],
    [
        1723161600000,
        174
    ]
];

let LINE_CHART_DATA = [
    [
        1722470400000,
        225
    ],
    [
        1722556800000,
        389
    ],
    [
        1722643200000,
        287
    ],
    [
        1722729600000,
        128
    ],
    [
        1722816000000,
        178
    ],
    [
        1722902400000,
        227
    ],
    [
        1722988800000,
        119
    ],
    [
        1723075200000,
        140
    ],
    [
        1723161600000,
        174
    ]
];

// const COLUMN_CHART_DATA_ORIGINAL = {
//     "profit": [
//         [
//             1714521600000,
//             17257
//         ],
//         [
//             1714608000000,
//             36860
//         ],
//         [
//             1714694400000,
//             13384
//         ],
//         [
//             1714780800000,
//             21280
//         ],
//         [
//             1714867200000,
//             20402
//         ],
//         [
//             1714953600000,
//             17162
//         ],
//         [
//             1715040000000,
//             26282
//         ],
//         [
//             1715126400000,
//             6721
//         ],
//         [
//             1715212800000,
//             4473
//         ],
//         [
//             1715299200000,
//             24980
//         ],
//         [
//             1715385600000,
//             21656
//         ],
//         [
//             1715472000000,
//             35055
//         ],
//         [
//             1715558400000,
//             6811
//         ],
//         [
//             1715644800000,
//             20692
//         ],
//         [
//             1715731200000,
//             37143
//         ],
//         [
//             1715817600000,
//             27661
//         ],
//         [
//             1715904000000,
//             1898
//         ],
//         [
//             1715990400000,
//             8471
//         ],
//         [
//             1716076800000,
//             12728
//         ],
//         [
//             1716163200000,
//             22130
//         ],
//         [
//             1716249600000,
//             38290
//         ],
//         [
//             1716336000000,
//             1483
//         ],
//         [
//             1716422400000,
//             32255
//         ],
//         [
//             1716508800000,
//             10978
//         ],
//         [
//             1716595200000,
//             35117
//         ],
//         [
//             1716681600000,
//             16467
//         ],
//         [
//             1716768000000,
//             30932
//         ],
//         [
//             1716854400000,
//             38863
//         ],
//         [
//             1716940800000,
//             34904
//         ],
//         [
//             1717027200000,
//             6873
//         ],
//         [
//             1717113600000,
//             29834
//         ],
//         [
//             1717200000000,
//             10916
//         ],
//         [
//             1717286400000,
//             9232
//         ],
//         [
//             1717372800000,
//             25865
//         ],
//         [
//             1717459200000,
//             10434
//         ],
//         [
//             1717545600000,
//             39262
//         ],
//         [
//             1717632000000,
//             24479
//         ],
//         [
//             1717718400000,
//             34741
//         ],
//         [
//             1717804800000,
//             11584
//         ],
//         [
//             1717891200000,
//             15036
//         ],
//         [
//             1717977600000,
//             20338
//         ],
//         [
//             1718064000000,
//             13795
//         ],
//         [
//             1718150400000,
//             14371
//         ],
//         [
//             1718236800000,
//             29369
//         ],
//         [
//             1718323200000,
//             16989
//         ],
//         [
//             1718409600000,
//             21264
//         ],
//         [
//             1718496000000,
//             33392
//         ],
//         [
//             1718582400000,
//             14523
//         ],
//         [
//             1718668800000,
//             28478
//         ],
//         [
//             1718755200000,
//             37910
//         ],
//         [
//             1718841600000,
//             2146
//         ],
//         [
//             1718928000000,
//             17088
//         ],
//         [
//             1719014400000,
//             23459
//         ],
//         [
//             1719100800000,
//             36729
//         ],
//         [
//             1719187200000,
//             5714
//         ],
//         [
//             1719273600000,
//             33193
//         ],
//         [
//             1719360000000,
//             38477
//         ],
//         [
//             1719446400000,
//             30984
//         ],
//         [
//             1719532800000,
//             1159
//         ],
//         [
//             1719619200000,
//             14424
//         ],
//         [
//             1719705600000,
//             13368
//         ],
//         [
//             1719792000000,
//             22280
//         ],
//         [
//             1719878400000,
//             395
//         ],
//         [
//             1719964800000,
//             9574
//         ],
//         [
//             1720051200000,
//             300
//         ],
//         [
//             1720137600000,
//             12024
//         ],
//         [
//             1720224000000,
//             12464
//         ],
//         [
//             1720310400000,
//             26418
//         ],
//         [
//             1720396800000,
//             2766
//         ],
//         [
//             1720483200000,
//             35603
//         ],
//         [
//             1720569600000,
//             12524
//         ],
//         [
//             1720656000000,
//             26705
//         ],
//         [
//             1720742400000,
//             34563
//         ],
//         [
//             1720828800000,
//             3046
//         ],
//         [
//             1720915200000,
//             28484
//         ],
//         [
//             1721001600000,
//             2768
//         ],
//         [
//             1721088000000,
//             6050
//         ],
//         [
//             1721174400000,
//             27742
//         ],
//         [
//             1721260800000,
//             6786
//         ],
//         [
//             1721347200000,
//             24744
//         ],
//         [
//             1721433600000,
//             14259
//         ],
//         [
//             1721520000000,
//             8819
//         ],
//         [
//             1721606400000,
//             33107
//         ],
//         [
//             1721692800000,
//             36907
//         ],
//         [
//             1721779200000,
//             5223
//         ],
//         [
//             1721865600000,
//             5931
//         ],
//         [
//             1721952000000,
//             32927
//         ],
//         [
//             1722038400000,
//             34999
//         ],
//         [
//             1722124800000,
//             22676
//         ],
//         [
//             1722211200000,
//             38114
//         ],
//         [
//             1722297600000,
//             13043
//         ],
//         [
//             1722384000000,
//             36648
//         ]
//     ],
//     "expectedProfit": [
//         [
//             1714521600000,
//             39090
//         ],
//         [
//             1714608000000,
//             19133
//         ],
//         [
//             1714694400000,
//             1591
//         ],
//         [
//             1714780800000,
//             22355
//         ],
//         [
//             1714867200000,
//             38736
//         ],
//         [
//             1714953600000,
//             20744
//         ],
//         [
//             1715040000000,
//             2144
//         ],
//         [
//             1715126400000,
//             35585
//         ],
//         [
//             1715212800000,
//             9670
//         ],
//         [
//             1715299200000,
//             7604
//         ],
//         [
//             1715385600000,
//             1627
//         ],
//         [
//             1715472000000,
//             3869
//         ],
//         [
//             1715558400000,
//             35987
//         ],
//         [
//             1715644800000,
//             23798
//         ],
//         [
//             1715731200000,
//             37173
//         ],
//         [
//             1715817600000,
//             17786
//         ],
//         [
//             1715904000000,
//             4728
//         ],
//         [
//             1715990400000,
//             14396
//         ],
//         [
//             1716076800000,
//             7949
//         ],
//         [
//             1716163200000,
//             32751
//         ],
//         [
//             1716249600000,
//             18706
//         ],
//         [
//             1716336000000,
//             23770
//         ],
//         [
//             1716422400000,
//             39455
//         ],
//         [
//             1716508800000,
//             11580
//         ],
//         [
//             1716595200000,
//             20346
//         ],
//         [
//             1716681600000,
//             39374
//         ],
//         [
//             1716768000000,
//             27071
//         ],
//         [
//             1716854400000,
//             19360
//         ],
//         [
//             1716940800000,
//             38798
//         ],
//         [
//             1717027200000,
//             22353
//         ],
//         [
//             1717113600000,
//             39578
//         ],
//         [
//             1717200000000,
//             24270
//         ],
//         [
//             1717286400000,
//             25578
//         ],
//         [
//             1717372800000,
//             37739
//         ],
//         [
//             1717459200000,
//             21558
//         ],
//         [
//             1717545600000,
//             15887
//         ],
//         [
//             1717632000000,
//             22898
//         ],
//         [
//             1717718400000,
//             32464
//         ],
//         [
//             1717804800000,
//             8295
//         ],
//         [
//             1717891200000,
//             18762
//         ],
//         [
//             1717977600000,
//             21155
//         ],
//         [
//             1718064000000,
//             9412
//         ],
//         [
//             1718150400000,
//             28487
//         ],
//         [
//             1718236800000,
//             33008
//         ],
//         [
//             1718323200000,
//             39929
//         ],
//         [
//             1718409600000,
//             9774
//         ],
//         [
//             1718496000000,
//             20029
//         ],
//         [
//             1718582400000,
//             7423
//         ],
//         [
//             1718668800000,
//             268
//         ],
//         [
//             1718755200000,
//             24335
//         ],
//         [
//             1718841600000,
//             4349
//         ],
//         [
//             1718928000000,
//             20341
//         ],
//         [
//             1719014400000,
//             22133
//         ],
//         [
//             1719100800000,
//             38896
//         ],
//         [
//             1719187200000,
//             26561
//         ],
//         [
//             1719273600000,
//             26206
//         ],
//         [
//             1719360000000,
//             19008
//         ],
//         [
//             1719446400000,
//             26251
//         ],
//         [
//             1719532800000,
//             3375
//         ],
//         [
//             1719619200000,
//             10471
//         ],
//         [
//             1719705600000,
//             37775
//         ],
//         [
//             1719792000000,
//             7094
//         ],
//         [
//             1719878400000,
//             23526
//         ],
//         [
//             1719964800000,
//             31064
//         ],
//         [
//             1720051200000,
//             25269
//         ],
//         [
//             1720137600000,
//             31927
//         ],
//         [
//             1720224000000,
//             5017
//         ],
//         [
//             1720310400000,
//             5294
//         ],
//         [
//             1720396800000,
//             20152
//         ],
//         [
//             1720483200000,
//             23455
//         ],
//         [
//             1720569600000,
//             24985
//         ],
//         [
//             1720656000000,
//             13030
//         ],
//         [
//             1720742400000,
//             38088
//         ],
//         [
//             1720828800000,
//             36173
//         ],
//         [
//             1720915200000,
//             19980
//         ],
//         [
//             1721001600000,
//             36198
//         ],
//         [
//             1721088000000,
//             22549
//         ],
//         [
//             1721174400000,
//             30282
//         ],
//         [
//             1721260800000,
//             255
//         ],
//         [
//             1721347200000,
//             22082
//         ],
//         [
//             1721433600000,
//             21601
//         ],
//         [
//             1721520000000,
//             28403
//         ],
//         [
//             1721606400000,
//             31890
//         ],
//         [
//             1721692800000,
//             7309
//         ],
//         [
//             1721779200000,
//             17126
//         ],
//         [
//             1721865600000,
//             24790
//         ],
//         [
//             1721952000000,
//             5494
//         ],
//         [
//             1722038400000,
//             15993
//         ],
//         [
//             1722124800000,
//             33412
//         ],
//         [
//             1722211200000,
//             38278
//         ],
//         [
//             1722297600000,
//             16678
//         ],
//         [
//             1722384000000,
//             2584
//         ]
//     ],
//     "revenue": [
//         [
//             1714521600000,
//             9992
//         ],
//         [
//             1714608000000,
//             15572
//         ],
//         [
//             1714694400000,
//             37455
//         ],
//         [
//             1714780800000,
//             15766
//         ],
//         [
//             1714867200000,
//             27397
//         ],
//         [
//             1714953600000,
//             32429
//         ],
//         [
//             1715040000000,
//             35957
//         ],
//         [
//             1715126400000,
//             38172
//         ],
//         [
//             1715212800000,
//             8448
//         ],
//         [
//             1715299200000,
//             36733
//         ],
//         [
//             1715385600000,
//             39832
//         ],
//         [
//             1715472000000,
//             17617
//         ],
//         [
//             1715558400000,
//             8752
//         ],
//         [
//             1715644800000,
//             22903
//         ],
//         [
//             1715731200000,
//             23
//         ],
//         [
//             1715817600000,
//             8341
//         ],
//         [
//             1715904000000,
//             4136
//         ],
//         [
//             1715990400000,
//             20652
//         ],
//         [
//             1716076800000,
//             19779
//         ],
//         [
//             1716163200000,
//             17768
//         ],
//         [
//             1716249600000,
//             31615
//         ],
//         [
//             1716336000000,
//             36710
//         ],
//         [
//             1716422400000,
//             34019
//         ],
//         [
//             1716508800000,
//             37649
//         ],
//         [
//             1716595200000,
//             17973
//         ],
//         [
//             1716681600000,
//             25331
//         ],
//         [
//             1716768000000,
//             2138
//         ],
//         [
//             1716854400000,
//             5908
//         ],
//         [
//             1716940800000,
//             23074
//         ],
//         [
//             1717027200000,
//             16222
//         ],
//         [
//             1717113600000,
//             5181
//         ],
//         [
//             1717200000000,
//             14631
//         ],
//         [
//             1717286400000,
//             24082
//         ],
//         [
//             1717372800000,
//             27961
//         ],
//         [
//             1717459200000,
//             3990
//         ],
//         [
//             1717545600000,
//             5683
//         ],
//         [
//             1717632000000,
//             13971
//         ],
//         [
//             1717718400000,
//             30659
//         ],
//         [
//             1717804800000,
//             14223
//         ],
//         [
//             1717891200000,
//             5713
//         ],
//         [
//             1717977600000,
//             21768
//         ],
//         [
//             1718064000000,
//             18294
//         ],
//         [
//             1718150400000,
//             309
//         ],
//         [
//             1718236800000,
//             17053
//         ],
//         [
//             1718323200000,
//             10924
//         ],
//         [
//             1718409600000,
//             29211
//         ],
//         [
//             1718496000000,
//             2352
//         ],
//         [
//             1718582400000,
//             20304
//         ],
//         [
//             1718668800000,
//             29392
//         ],
//         [
//             1718755200000,
//             12255
//         ],
//         [
//             1718841600000,
//             27993
//         ],
//         [
//             1718928000000,
//             24448
//         ],
//         [
//             1719014400000,
//             2481
//         ],
//         [
//             1719100800000,
//             30573
//         ],
//         [
//             1719187200000,
//             22269
//         ],
//         [
//             1719273600000,
//             34063
//         ],
//         [
//             1719360000000,
//             10127
//         ],
//         [
//             1719446400000,
//             33073
//         ],
//         [
//             1719532800000,
//             7808
//         ],
//         [
//             1719619200000,
//             18231
//         ],
//         [
//             1719705600000,
//             37156
//         ],
//         [
//             1719792000000,
//             32007
//         ],
//         [
//             1719878400000,
//             26334
//         ],
//         [
//             1719964800000,
//             35230
//         ],
//         [
//             1720051200000,
//             11047
//         ],
//         [
//             1720137600000,
//             17756
//         ],
//         [
//             1720224000000,
//             26083
//         ],
//         [
//             1720310400000,
//             6195
//         ],
//         [
//             1720396800000,
//             37964
//         ],
//         [
//             1720483200000,
//             15123
//         ],
//         [
//             1720569600000,
//             27542
//         ],
//         [
//             1720656000000,
//             24724
//         ],
//         [
//             1720742400000,
//             3240
//         ],
//         [
//             1720828800000,
//             38562
//         ],
//         [
//             1720915200000,
//             1567
//         ],
//         [
//             1721001600000,
//             29083
//         ],
//         [
//             1721088000000,
//             19117
//         ],
//         [
//             1721174400000,
//             7851
//         ],
//         [
//             1721260800000,
//             29694
//         ],
//         [
//             1721347200000,
//             29326
//         ],
//         [
//             1721433600000,
//             10133
//         ],
//         [
//             1721520000000,
//             9148
//         ],
//         [
//             1721606400000,
//             39010
//         ],
//         [
//             1721692800000,
//             33933
//         ],
//         [
//             1721779200000,
//             32427
//         ],
//         [
//             1721865600000,
//             18921
//         ],
//         [
//             1721952000000,
//             188
//         ],
//         [
//             1722038400000,
//             34400
//         ],
//         [
//             1722124800000,
//             22052
//         ],
//         [
//             1722211200000,
//             15798
//         ],
//         [
//             1722297600000,
//             13954
//         ],
//         [
//             1722384000000,
//             9843
//         ]
//     ],
//     "expectedRevenue": [
//         [
//             1714521600000,
//             15521
//         ],
//         [
//             1714608000000,
//             8368
//         ],
//         [
//             1714694400000,
//             3045
//         ],
//         [
//             1714780800000,
//             18400
//         ],
//         [
//             1714867200000,
//             22769
//         ],
//         [
//             1714953600000,
//             26957
//         ],
//         [
//             1715040000000,
//             5403
//         ],
//         [
//             1715126400000,
//             25348
//         ],
//         [
//             1715212800000,
//             9943
//         ],
//         [
//             1715299200000,
//             8287
//         ],
//         [
//             1715385600000,
//             30143
//         ],
//         [
//             1715472000000,
//             38282
//         ],
//         [
//             1715558400000,
//             7556
//         ],
//         [
//             1715644800000,
//             6800
//         ],
//         [
//             1715731200000,
//             27784
//         ],
//         [
//             1715817600000,
//             9638
//         ],
//         [
//             1715904000000,
//             4043
//         ],
//         [
//             1715990400000,
//             29500
//         ],
//         [
//             1716076800000,
//             807
//         ],
//         [
//             1716163200000,
//             27944
//         ],
//         [
//             1716249600000,
//             4463
//         ],
//         [
//             1716336000000,
//             9614
//         ],
//         [
//             1716422400000,
//             35115
//         ],
//         [
//             1716508800000,
//             15593
//         ],
//         [
//             1716595200000,
//             2469
//         ],
//         [
//             1716681600000,
//             34814
//         ],
//         [
//             1716768000000,
//             496
//         ],
//         [
//             1716854400000,
//             2019
//         ],
//         [
//             1716940800000,
//             6990
//         ],
//         [
//             1717027200000,
//             5196
//         ],
//         [
//             1717113600000,
//             9032
//         ],
//         [
//             1717200000000,
//             14780
//         ],
//         [
//             1717286400000,
//             680
//         ],
//         [
//             1717372800000,
//             498
//         ],
//         [
//             1717459200000,
//             38824
//         ],
//         [
//             1717545600000,
//             29103
//         ],
//         [
//             1717632000000,
//             32957
//         ],
//         [
//             1717718400000,
//             36925
//         ],
//         [
//             1717804800000,
//             31802
//         ],
//         [
//             1717891200000,
//             18307
//         ],
//         [
//             1717977600000,
//             11512
//         ],
//         [
//             1718064000000,
//             18185
//         ],
//         [
//             1718150400000,
//             39938
//         ],
//         [
//             1718236800000,
//             36764
//         ],
//         [
//             1718323200000,
//             19033
//         ],
//         [
//             1718409600000,
//             32684
//         ],
//         [
//             1718496000000,
//             11384
//         ],
//         [
//             1718582400000,
//             2869
//         ],
//         [
//             1718668800000,
//             735
//         ],
//         [
//             1718755200000,
//             13249
//         ],
//         [
//             1718841600000,
//             36446
//         ],
//         [
//             1718928000000,
//             1864
//         ],
//         [
//             1719014400000,
//             1636
//         ],
//         [
//             1719100800000,
//             26639
//         ],
//         [
//             1719187200000,
//             938
//         ],
//         [
//             1719273600000,
//             30018
//         ],
//         [
//             1719360000000,
//             34564
//         ],
//         [
//             1719446400000,
//             32259
//         ],
//         [
//             1719532800000,
//             3501
//         ],
//         [
//             1719619200000,
//             1441
//         ],
//         [
//             1719705600000,
//             2693
//         ],
//         [
//             1719792000000,
//             29087
//         ],
//         [
//             1719878400000,
//             16593
//         ],
//         [
//             1719964800000,
//             34359
//         ],
//         [
//             1720051200000,
//             6704
//         ],
//         [
//             1720137600000,
//             35844
//         ],
//         [
//             1720224000000,
//             17801
//         ],
//         [
//             1720310400000,
//             6124
//         ],
//         [
//             1720396800000,
//             34671
//         ],
//         [
//             1720483200000,
//             5049
//         ],
//         [
//             1720569600000,
//             10233
//         ],
//         [
//             1720656000000,
//             14210
//         ],
//         [
//             1720742400000,
//             1240
//         ],
//         [
//             1720828800000,
//             34600
//         ],
//         [
//             1720915200000,
//             25673
//         ],
//         [
//             1721001600000,
//             21638
//         ],
//         [
//             1721088000000,
//             13196
//         ],
//         [
//             1721174400000,
//             10985
//         ],
//         [
//             1721260800000,
//             23901
//         ],
//         [
//             1721347200000,
//             31536
//         ],
//         [
//             1721433600000,
//             16263
//         ],
//         [
//             1721520000000,
//             34341
//         ],
//         [
//             1721606400000,
//             34351
//         ],
//         [
//             1721692800000,
//             30255
//         ],
//         [
//             1721779200000,
//             25625
//         ],
//         [
//             1721865600000,
//             38888
//         ],
//         [
//             1721952000000,
//             15032
//         ],
//         [
//             1722038400000,
//             1059
//         ],
//         [
//             1722124800000,
//             21813
//         ],
//         [
//             1722211200000,
//             37030
//         ],
//         [
//             1722297600000,
//             24559
//         ],
//         [
//             1722384000000,
//             29628
//         ]
//     ],
// };

// let COLUMN_CHART_DATA = {
//     "profit": [
//         [
//             1714521600000,
//             17257
//         ],
//         [
//             1714608000000,
//             36860
//         ],
//         [
//             1714694400000,
//             13384
//         ],
//         [
//             1714780800000,
//             21280
//         ],
//         [
//             1714867200000,
//             20402
//         ],
//         [
//             1714953600000,
//             17162
//         ],
//         [
//             1715040000000,
//             26282
//         ],
//         [
//             1715126400000,
//             6721
//         ],
//         [
//             1715212800000,
//             4473
//         ],
//         [
//             1715299200000,
//             24980
//         ],
//         [
//             1715385600000,
//             21656
//         ],
//         [
//             1715472000000,
//             35055
//         ],
//         [
//             1715558400000,
//             6811
//         ],
//         [
//             1715644800000,
//             20692
//         ],
//         [
//             1715731200000,
//             37143
//         ],
//         [
//             1715817600000,
//             27661
//         ],
//         [
//             1715904000000,
//             1898
//         ],
//         [
//             1715990400000,
//             8471
//         ],
//         [
//             1716076800000,
//             12728
//         ],
//         [
//             1716163200000,
//             22130
//         ],
//         [
//             1716249600000,
//             38290
//         ],
//         [
//             1716336000000,
//             1483
//         ],
//         [
//             1716422400000,
//             32255
//         ],
//         [
//             1716508800000,
//             10978
//         ],
//         [
//             1716595200000,
//             35117
//         ],
//         [
//             1716681600000,
//             16467
//         ],
//         [
//             1716768000000,
//             30932
//         ],
//         [
//             1716854400000,
//             38863
//         ],
//         [
//             1716940800000,
//             34904
//         ],
//         [
//             1717027200000,
//             6873
//         ],
//         [
//             1717113600000,
//             29834
//         ],
//         [
//             1717200000000,
//             10916
//         ],
//         [
//             1717286400000,
//             9232
//         ],
//         [
//             1717372800000,
//             25865
//         ],
//         [
//             1717459200000,
//             10434
//         ],
//         [
//             1717545600000,
//             39262
//         ],
//         [
//             1717632000000,
//             24479
//         ],
//         [
//             1717718400000,
//             34741
//         ],
//         [
//             1717804800000,
//             11584
//         ],
//         [
//             1717891200000,
//             15036
//         ],
//         [
//             1717977600000,
//             20338
//         ],
//         [
//             1718064000000,
//             13795
//         ],
//         [
//             1718150400000,
//             14371
//         ],
//         [
//             1718236800000,
//             29369
//         ],
//         [
//             1718323200000,
//             16989
//         ],
//         [
//             1718409600000,
//             21264
//         ],
//         [
//             1718496000000,
//             33392
//         ],
//         [
//             1718582400000,
//             14523
//         ],
//         [
//             1718668800000,
//             28478
//         ],
//         [
//             1718755200000,
//             37910
//         ],
//         [
//             1718841600000,
//             2146
//         ],
//         [
//             1718928000000,
//             17088
//         ],
//         [
//             1719014400000,
//             23459
//         ],
//         [
//             1719100800000,
//             36729
//         ],
//         [
//             1719187200000,
//             5714
//         ],
//         [
//             1719273600000,
//             33193
//         ],
//         [
//             1719360000000,
//             38477
//         ],
//         [
//             1719446400000,
//             30984
//         ],
//         [
//             1719532800000,
//             1159
//         ],
//         [
//             1719619200000,
//             14424
//         ],
//         [
//             1719705600000,
//             13368
//         ],
//         [
//             1719792000000,
//             22280
//         ],
//         [
//             1719878400000,
//             395
//         ],
//         [
//             1719964800000,
//             9574
//         ],
//         [
//             1720051200000,
//             300
//         ],
//         [
//             1720137600000,
//             12024
//         ],
//         [
//             1720224000000,
//             12464
//         ],
//         [
//             1720310400000,
//             26418
//         ],
//         [
//             1720396800000,
//             2766
//         ],
//         [
//             1720483200000,
//             35603
//         ],
//         [
//             1720569600000,
//             12524
//         ],
//         [
//             1720656000000,
//             26705
//         ],
//         [
//             1720742400000,
//             34563
//         ],
//         [
//             1720828800000,
//             3046
//         ],
//         [
//             1720915200000,
//             28484
//         ],
//         [
//             1721001600000,
//             2768
//         ],
//         [
//             1721088000000,
//             6050
//         ],
//         [
//             1721174400000,
//             27742
//         ],
//         [
//             1721260800000,
//             6786
//         ],
//         [
//             1721347200000,
//             24744
//         ],
//         [
//             1721433600000,
//             14259
//         ],
//         [
//             1721520000000,
//             8819
//         ],
//         [
//             1721606400000,
//             33107
//         ],
//         [
//             1721692800000,
//             36907
//         ],
//         [
//             1721779200000,
//             5223
//         ],
//         [
//             1721865600000,
//             5931
//         ],
//         [
//             1721952000000,
//             32927
//         ],
//         [
//             1722038400000,
//             34999
//         ],
//         [
//             1722124800000,
//             22676
//         ],
//         [
//             1722211200000,
//             38114
//         ],
//         [
//             1722297600000,
//             13043
//         ],
//         [
//             1722384000000,
//             36648
//         ]
//     ],
//     "expectedProfit": [
//         [
//             1714521600000,
//             39090
//         ],
//         [
//             1714608000000,
//             19133
//         ],
//         [
//             1714694400000,
//             1591
//         ],
//         [
//             1714780800000,
//             22355
//         ],
//         [
//             1714867200000,
//             38736
//         ],
//         [
//             1714953600000,
//             20744
//         ],
//         [
//             1715040000000,
//             2144
//         ],
//         [
//             1715126400000,
//             35585
//         ],
//         [
//             1715212800000,
//             9670
//         ],
//         [
//             1715299200000,
//             7604
//         ],
//         [
//             1715385600000,
//             1627
//         ],
//         [
//             1715472000000,
//             3869
//         ],
//         [
//             1715558400000,
//             35987
//         ],
//         [
//             1715644800000,
//             23798
//         ],
//         [
//             1715731200000,
//             37173
//         ],
//         [
//             1715817600000,
//             17786
//         ],
//         [
//             1715904000000,
//             4728
//         ],
//         [
//             1715990400000,
//             14396
//         ],
//         [
//             1716076800000,
//             7949
//         ],
//         [
//             1716163200000,
//             32751
//         ],
//         [
//             1716249600000,
//             18706
//         ],
//         [
//             1716336000000,
//             23770
//         ],
//         [
//             1716422400000,
//             39455
//         ],
//         [
//             1716508800000,
//             11580
//         ],
//         [
//             1716595200000,
//             20346
//         ],
//         [
//             1716681600000,
//             39374
//         ],
//         [
//             1716768000000,
//             27071
//         ],
//         [
//             1716854400000,
//             19360
//         ],
//         [
//             1716940800000,
//             38798
//         ],
//         [
//             1717027200000,
//             22353
//         ],
//         [
//             1717113600000,
//             39578
//         ],
//         [
//             1717200000000,
//             24270
//         ],
//         [
//             1717286400000,
//             25578
//         ],
//         [
//             1717372800000,
//             37739
//         ],
//         [
//             1717459200000,
//             21558
//         ],
//         [
//             1717545600000,
//             15887
//         ],
//         [
//             1717632000000,
//             22898
//         ],
//         [
//             1717718400000,
//             32464
//         ],
//         [
//             1717804800000,
//             8295
//         ],
//         [
//             1717891200000,
//             18762
//         ],
//         [
//             1717977600000,
//             21155
//         ],
//         [
//             1718064000000,
//             9412
//         ],
//         [
//             1718150400000,
//             28487
//         ],
//         [
//             1718236800000,
//             33008
//         ],
//         [
//             1718323200000,
//             39929
//         ],
//         [
//             1718409600000,
//             9774
//         ],
//         [
//             1718496000000,
//             20029
//         ],
//         [
//             1718582400000,
//             7423
//         ],
//         [
//             1718668800000,
//             268
//         ],
//         [
//             1718755200000,
//             24335
//         ],
//         [
//             1718841600000,
//             4349
//         ],
//         [
//             1718928000000,
//             20341
//         ],
//         [
//             1719014400000,
//             22133
//         ],
//         [
//             1719100800000,
//             38896
//         ],
//         [
//             1719187200000,
//             26561
//         ],
//         [
//             1719273600000,
//             26206
//         ],
//         [
//             1719360000000,
//             19008
//         ],
//         [
//             1719446400000,
//             26251
//         ],
//         [
//             1719532800000,
//             3375
//         ],
//         [
//             1719619200000,
//             10471
//         ],
//         [
//             1719705600000,
//             37775
//         ],
//         [
//             1719792000000,
//             7094
//         ],
//         [
//             1719878400000,
//             23526
//         ],
//         [
//             1719964800000,
//             31064
//         ],
//         [
//             1720051200000,
//             25269
//         ],
//         [
//             1720137600000,
//             31927
//         ],
//         [
//             1720224000000,
//             5017
//         ],
//         [
//             1720310400000,
//             5294
//         ],
//         [
//             1720396800000,
//             20152
//         ],
//         [
//             1720483200000,
//             23455
//         ],
//         [
//             1720569600000,
//             24985
//         ],
//         [
//             1720656000000,
//             13030
//         ],
//         [
//             1720742400000,
//             38088
//         ],
//         [
//             1720828800000,
//             36173
//         ],
//         [
//             1720915200000,
//             19980
//         ],
//         [
//             1721001600000,
//             36198
//         ],
//         [
//             1721088000000,
//             22549
//         ],
//         [
//             1721174400000,
//             30282
//         ],
//         [
//             1721260800000,
//             255
//         ],
//         [
//             1721347200000,
//             22082
//         ],
//         [
//             1721433600000,
//             21601
//         ],
//         [
//             1721520000000,
//             28403
//         ],
//         [
//             1721606400000,
//             31890
//         ],
//         [
//             1721692800000,
//             7309
//         ],
//         [
//             1721779200000,
//             17126
//         ],
//         [
//             1721865600000,
//             24790
//         ],
//         [
//             1721952000000,
//             5494
//         ],
//         [
//             1722038400000,
//             15993
//         ],
//         [
//             1722124800000,
//             33412
//         ],
//         [
//             1722211200000,
//             38278
//         ],
//         [
//             1722297600000,
//             16678
//         ],
//         [
//             1722384000000,
//             2584
//         ]
//     ],
//     "revenue": [
//         [
//             1714521600000,
//             9992
//         ],
//         [
//             1714608000000,
//             15572
//         ],
//         [
//             1714694400000,
//             37455
//         ],
//         [
//             1714780800000,
//             15766
//         ],
//         [
//             1714867200000,
//             27397
//         ],
//         [
//             1714953600000,
//             32429
//         ],
//         [
//             1715040000000,
//             35957
//         ],
//         [
//             1715126400000,
//             38172
//         ],
//         [
//             1715212800000,
//             8448
//         ],
//         [
//             1715299200000,
//             36733
//         ],
//         [
//             1715385600000,
//             39832
//         ],
//         [
//             1715472000000,
//             17617
//         ],
//         [
//             1715558400000,
//             8752
//         ],
//         [
//             1715644800000,
//             22903
//         ],
//         [
//             1715731200000,
//             23
//         ],
//         [
//             1715817600000,
//             8341
//         ],
//         [
//             1715904000000,
//             4136
//         ],
//         [
//             1715990400000,
//             20652
//         ],
//         [
//             1716076800000,
//             19779
//         ],
//         [
//             1716163200000,
//             17768
//         ],
//         [
//             1716249600000,
//             31615
//         ],
//         [
//             1716336000000,
//             36710
//         ],
//         [
//             1716422400000,
//             34019
//         ],
//         [
//             1716508800000,
//             37649
//         ],
//         [
//             1716595200000,
//             17973
//         ],
//         [
//             1716681600000,
//             25331
//         ],
//         [
//             1716768000000,
//             2138
//         ],
//         [
//             1716854400000,
//             5908
//         ],
//         [
//             1716940800000,
//             23074
//         ],
//         [
//             1717027200000,
//             16222
//         ],
//         [
//             1717113600000,
//             5181
//         ],
//         [
//             1717200000000,
//             14631
//         ],
//         [
//             1717286400000,
//             24082
//         ],
//         [
//             1717372800000,
//             27961
//         ],
//         [
//             1717459200000,
//             3990
//         ],
//         [
//             1717545600000,
//             5683
//         ],
//         [
//             1717632000000,
//             13971
//         ],
//         [
//             1717718400000,
//             30659
//         ],
//         [
//             1717804800000,
//             14223
//         ],
//         [
//             1717891200000,
//             5713
//         ],
//         [
//             1717977600000,
//             21768
//         ],
//         [
//             1718064000000,
//             18294
//         ],
//         [
//             1718150400000,
//             309
//         ],
//         [
//             1718236800000,
//             17053
//         ],
//         [
//             1718323200000,
//             10924
//         ],
//         [
//             1718409600000,
//             29211
//         ],
//         [
//             1718496000000,
//             2352
//         ],
//         [
//             1718582400000,
//             20304
//         ],
//         [
//             1718668800000,
//             29392
//         ],
//         [
//             1718755200000,
//             12255
//         ],
//         [
//             1718841600000,
//             27993
//         ],
//         [
//             1718928000000,
//             24448
//         ],
//         [
//             1719014400000,
//             2481
//         ],
//         [
//             1719100800000,
//             30573
//         ],
//         [
//             1719187200000,
//             22269
//         ],
//         [
//             1719273600000,
//             34063
//         ],
//         [
//             1719360000000,
//             10127
//         ],
//         [
//             1719446400000,
//             33073
//         ],
//         [
//             1719532800000,
//             7808
//         ],
//         [
//             1719619200000,
//             18231
//         ],
//         [
//             1719705600000,
//             37156
//         ],
//         [
//             1719792000000,
//             32007
//         ],
//         [
//             1719878400000,
//             26334
//         ],
//         [
//             1719964800000,
//             35230
//         ],
//         [
//             1720051200000,
//             11047
//         ],
//         [
//             1720137600000,
//             17756
//         ],
//         [
//             1720224000000,
//             26083
//         ],
//         [
//             1720310400000,
//             6195
//         ],
//         [
//             1720396800000,
//             37964
//         ],
//         [
//             1720483200000,
//             15123
//         ],
//         [
//             1720569600000,
//             27542
//         ],
//         [
//             1720656000000,
//             24724
//         ],
//         [
//             1720742400000,
//             3240
//         ],
//         [
//             1720828800000,
//             38562
//         ],
//         [
//             1720915200000,
//             1567
//         ],
//         [
//             1721001600000,
//             29083
//         ],
//         [
//             1721088000000,
//             19117
//         ],
//         [
//             1721174400000,
//             7851
//         ],
//         [
//             1721260800000,
//             29694
//         ],
//         [
//             1721347200000,
//             29326
//         ],
//         [
//             1721433600000,
//             10133
//         ],
//         [
//             1721520000000,
//             9148
//         ],
//         [
//             1721606400000,
//             39010
//         ],
//         [
//             1721692800000,
//             33933
//         ],
//         [
//             1721779200000,
//             32427
//         ],
//         [
//             1721865600000,
//             18921
//         ],
//         [
//             1721952000000,
//             188
//         ],
//         [
//             1722038400000,
//             34400
//         ],
//         [
//             1722124800000,
//             22052
//         ],
//         [
//             1722211200000,
//             15798
//         ],
//         [
//             1722297600000,
//             13954
//         ],
//         [
//             1722384000000,
//             9843
//         ]
//     ],
//     "expectedRevenue": [
//         [
//             1714521600000,
//             15521
//         ],
//         [
//             1714608000000,
//             8368
//         ],
//         [
//             1714694400000,
//             3045
//         ],
//         [
//             1714780800000,
//             18400
//         ],
//         [
//             1714867200000,
//             22769
//         ],
//         [
//             1714953600000,
//             26957
//         ],
//         [
//             1715040000000,
//             5403
//         ],
//         [
//             1715126400000,
//             25348
//         ],
//         [
//             1715212800000,
//             9943
//         ],
//         [
//             1715299200000,
//             8287
//         ],
//         [
//             1715385600000,
//             30143
//         ],
//         [
//             1715472000000,
//             38282
//         ],
//         [
//             1715558400000,
//             7556
//         ],
//         [
//             1715644800000,
//             6800
//         ],
//         [
//             1715731200000,
//             27784
//         ],
//         [
//             1715817600000,
//             9638
//         ],
//         [
//             1715904000000,
//             4043
//         ],
//         [
//             1715990400000,
//             29500
//         ],
//         [
//             1716076800000,
//             807
//         ],
//         [
//             1716163200000,
//             27944
//         ],
//         [
//             1716249600000,
//             4463
//         ],
//         [
//             1716336000000,
//             9614
//         ],"profit":
//         [
//             1716422400000,
//             35115
//         ],
//         [
//             1716508800000,
//             15593
//         ],
//         [
//             1716595200000,
//             2469
//         ],
//         [
//             1716681600000,
//             34814
//         ],
//         [
//             1716768000000,
//             496
//         ],
//         [
//             1716854400000,
//             2019
//         ],
//         [
//             1716940800000,
//             6990
//         ],
//         [
//             1717027200000,
//             5196
//         ],
//         [
//             1717113600000,
//             9032
//         ],
//         [
//             1717200000000,
//             14780
//         ],
//         [
//             1717286400000,
//             680
//         ],
//         [
//             1717372800000,
//             498
//         ],
//         [
//             1717459200000,
//             38824
//         ],
//         [
//             1717545600000,
//             29103
//         ],
//         [
//             1717632000000,
//             32957
//         ],
//         [
//             1717718400000,
//             36925
//         ],
//         [
//             1717804800000,
//             31802
//         ],
//         [
//             1717891200000,
//             18307
//         ],
//         [
//             1717977600000,
//             11512
//         ],
//         [
//             1718064000000,
//             18185
//         ],
//         [
//             1718150400000,
//             39938
//         ],
//         [
//             1718236800000,
//             36764
//         ],
//         [
//             1718323200000,
//             19033
//         ],
//         [
//             1718409600000,
//             32684
//         ],
//         [
//             1718496000000,
//             11384
//         ],
//         [
//             1718582400000,
//             2869
//         ],
//         [
//             1718668800000,
//             735
//         ],
//         [
//             1718755200000,
//             13249
//         ],
//         [
//             1718841600000,
//             36446
//         ],
//         [
//             1718928000000,
//             1864
//         ],
//         [
//             1719014400000,
//             1636
//         ],
//         [
//             1719100800000,
//             26639
//         ],
//         [
//             1719187200000,
//             938
//         ],
//         [
//             1719273600000,
//             30018
//         ],
//         [
//             1719360000000,
//             34564
//         ],
//         [
//             1719446400000,
//             32259
//         ],
//         [
//             1719532800000,
//             3501
//         ],
//         [
//             1719619200000,
//             1441
//         ],
//         [
//             1719705600000,
//             2693
//         ],
//         [
//             1719792000000,
//             29087
//         ],
//         [
//             1719878400000,
//             16593
//         ],
//         [
//             1719964800000,
//             34359
//         ],
//         [
//             1720051200000,
//             6704
//         ],
//         [
//             1720137600000,
//             35844
//         ],
//         [
//             1720224000000,
//             17801
//         ],
//         [
//             1720310400000,
//             6124
//         ],
//         [
//             1720396800000,
//             34671
//         ],
//         [
//             1720483200000,
//             5049
//         ],
//         [
//             1720569600000,
//             10233
//         ],
//         [
//             1720656000000,
//             14210
//         ],
//         [
//             1720742400000,
//             1240
//         ],
//         [
//             1720828800000,
//             34600
//         ],
//         [
//             1720915200000,
//             25673
//         ],
//         [
//             1721001600000,
//             21638
//         ],
//         [
//             1721088000000,
//             13196
//         ],
//         [
//             1721174400000,
//             10985
//         ],
//         [
//             1721260800000,
//             23901
//         ],
//         [
//             1721347200000,
//             31536
//         ],
//         [
//             1721433600000,
//             16263
//         ],
//         [
//             1721520000000,
//             34341
//         ],
//         [
//             1721606400000,
//             34351
//         ],
//         [
//             1721692800000,
//             30255
//         ],
//         [
//             1721779200000,
//             25625
//         ],
//         [
//             1721865600000,
//             38888
//         ],
//         [
//             1721952000000,
//             15032
//         ],
//         [
//             1722038400000,
//             1059
//         ],
//         [
//             1722124800000,
//             21813
//         ],
//         [
//             1722211200000,
//             37030
//         ],
//         [
//             1722297600000,
//             24559
//         ],
//         [
//             1722384000000,
//             29628
//         ]
//     ],
// };

//Chart options

const COLUMN_CHART_DATA_ORIGINAL = {
    "profit": [
        [
            1722470400000,
            3109
        ],
        [
            1722556800000,
            5003
        ],
        [
            1722643200000,
            9311
        ],
        [
            1722729600000,
            15401
        ],
        [
            1722816000000,
            3033
        ],
        [
            1722902400000,
            1287
        ],
        [
            1722988800000,
            13927
        ],
        [
            1723075200000,
            33927
        ],
        [
            1723161600000,
            907
        ]
    ],
    "revenue": [
        [
            1722470400000,
            16690
        ],
        [
            1722556800000,
            18033
        ],
        [
            1722643200000,
            18908
        ],
        [
            1722729600000,
            5143
        ],
        [
            1722816000000,
            20045
        ],
        [
            1722902400000,
            17161
        ],
        [
            1722988800000,
            34563
        ],
        [
            1723075200000,
            33331
        ],
        [
            1723161600000,
            10536
        ]
    ]
};

let COLUMN_CHART_DATA = {
    "profit": [
        [
            1722470400000,
            3109
        ],
        [
            1722556800000,
            5003
        ],
        [
            1722643200000,
            9311
        ],
        [
            1722729600000,
            15401
        ],
        [
            1722816000000,
            3033
        ],
        [
            1722902400000,
            1287
        ],
        [
            1722988800000,
            13927
        ],
        [
            1723075200000,
            33927
        ],
        [
            1723161600000,
            907
        ]
    ],
    "revenue": [
        [
            1722470400000,
            16690
        ],
        [
            1722556800000,
            18033
        ],
        [
            1722643200000,
            18908
        ],
        [
            1722729600000,
            5143
        ],
        [
            1722816000000,
            20045
        ],
        [
            1722902400000,
            17161
        ],
        [
            1722988800000,
            34563
        ],
        [
            1723075200000,
            33331
        ],
        [
            1723161600000,
            10536
        ]
    ]
}

const lineChartOptions = {
    chart: {
        type: 'spline',
        zoomType: 'x',
        zooming: {
            mouseWheel: {
                enabled:false
            }
        }
    },
    title: {
        text: 'Daily Basic Fare'
    },
    xAxis: {
        type: 'datetime',
        title: {
            text: 'Date'
        },
        labels: {
            format: '{value:%e %b}'
        },
        crosshair: true,
        events: {
            setExtremes: syncExtremes
        },
    },
    yAxis: [{
        title: {
            text: 'Basic Fare ($)'
        },
        min: 100,
        max: 500,
    },
    {
        title: {
            text: 'Basic Fare ($)'
        },
        min: 100,
        max: 500,
        opposite: true
    }],
    legend: {
        enabled: true
    },
    plotOptions: {
        series: {
            dataLabels: {
                enabled: true,
                format: '${point.y:.0f}'
            },
            stickyTracking: false,
            dragDrop: {
                draggableX: false,
                draggableY: true,
            },
            line: {
                cursor: "no-resize"
            }
        }
    },
    tooltip: {
        shared: false,
        valueDecimals: 0,
        valuePrefix: '$',
    },
    rangeSelector: {
        enabled: true,
        selected: 0,
        buttons: [{
            type: 'month',
            count: 1,
            text: '1m',
        }, {
            type: 'month',
            count: 3,
            text: '3m',
        }, {
            type: 'all',
            text: 'All',
        }],

    },
    stockTools: {
        gui: {
            enabled: false
        }
    },
    navigator: {
        enabled: true
    },
    series: [{
        name: 'Basic Fare',
        colorByPoint: true,
        data: LINE_CHART_DATA,
        point: {
            events: {
                drop: function (event) {
                    syncColumnCharts(this);
                },
            }
        },
    }],
};

const columnChartOptions = {
    chart: {
        type: 'column',
        zoomType: 'x',
        zooming: {
            mouseWheel: {
                enabled:false
            }
        }
    },
    title: {
        text: 'Revenue and Profit'
    },
    xAxis: {
        type: 'datetime',
        title: {
            text: 'Date'
        },
        labels: {
            format: '{value:%e %b}',
        },
    },
    yAxis: [{
        min: 0,
        title: {
            text: 'Revenue & Profit ($)'
        },
        labels: {
            formatter: function () {
                return '$' + this.value / 1000 + 'K';
            }
        }
    }, {
        title: {
            text: 'Revenue & Profit ($)'
        },
        labels: {
            formatter: function () {
                return '$' + this.value / 1000 + 'K';
            }
        },
        opposite: true
    }],
    rangeSelector: {
        enabled: false,
        selected: 0,
        buttons: [{
            type: 'month',
            count: 1,
            text: '1m',
        }, {
            type: 'month',
            count: 3,
            text: '3m'
        }, {
            type: 'all',
            text: 'All'
        }]
    },
    legend: {
        shadow: false
    },
    tooltip: {
        shared: false,
        valueDecimals: 0,
        valuePrefix: '$',
        formatter: function () {
            let series = this.point.series.chart.series,
                index = this.point.series.points.indexOf(this.point),
                str = '';

                let date = Highcharts.dateFormat('%A, %b %e, %Y', this.x); 

                str += date + '<br/>';

            for (let i = 0; i < series.length - 1; i++) {
                let color = series[i].color; // Get the color of the series
                let value = Math.round(series[i].points[index].y); 
                str += '<span style="color:' + color + '">●</span> ' + series[i].name + ': <strong>$' + value + '</strong><br/>';
            }
            return str;
        }
    },
    plotOptions: {
        column: {
            grouping: false,
            shadow: false,
            borderWidth: 0,
        }
    },
    stockTools: {
        gui: {
            enabled: false
        }
    },
    navigator: {
        enabled: false
    },
    series: [ {
        name: 'Profit',
        color: 'rgba(126,86,134,.9)',
        data: COLUMN_CHART_DATA.profit,
        tooltip: {
            valuePrefix: '$',
            valueSuffix: ''
        },
        pointPadding: 0.4,
        pointPlacement: -0.2
    }, {
        name: 'Revenue',
        color: 'rgba(186,60,61,.9)',
        data: COLUMN_CHART_DATA.revenue,
        tooltip: {
            valuePrefix: '$',
            valueSuffix: ''
        },
        pointPadding: 0.4,
        pointPlacement: 0.2,
        yAxis: 1
    }]
};

// Sync functions
function syncColumnCharts(chart) {
    const xValue = chart.options.x;
    const newPrice = chart.options.y;

    const linePointIndex = LINE_CHART_DATA_ORIGINAL.findIndex(point => point[0] === xValue);

    const columnChart = Highcharts.charts.find(chart => chart && chart.renderTo.id === 'column-12345');

    if (columnChart) {
        const columnPointIndex = COLUMN_CHART_DATA_ORIGINAL.profit.findIndex(point => point[0] === xValue);

        if (columnPointIndex !== -1) {
            const actualPrice = LINE_CHART_DATA_ORIGINAL[linePointIndex][1];
            const percentageChange = ((newPrice - actualPrice) / actualPrice) * 100;

            const profit = COLUMN_CHART_DATA_ORIGINAL.profit[columnPointIndex][1];
            const revenue = COLUMN_CHART_DATA_ORIGINAL.revenue[columnPointIndex][1];

            const newProfitTotal = profit + (profit * (percentageChange / 100));
            const newRevenueTotal = revenue + (revenue * (percentageChange / 100));

            columnChart.series[0].data[columnPointIndex].update(newProfitTotal);
            columnChart.series[1].data[columnPointIndex].update(newRevenueTotal);
        }
    }
}

/**
 * Synchronize zooming through the setExtremes event handler.
 */
function syncExtremes(e) {
    const thisChart = this.chart;

    if (e.trigger !== 'syncExtremes') { // Prevent feedback loop
        Highcharts.each(Highcharts.charts, function (chart) {
            if (chart !== thisChart) {
                if (chart?.xAxis[0]?.setExtremes) { // It is null while updating
                    chart.xAxis[0].setExtremes(
                        e.min,
                        e.max,
                        undefined,
                        false, {
                          trigger: 'syncExtremes'
                        }
                    );
                     // Keep focused if range selector clicked
                     const rangeMap = {
                        '1m': 0,
                        '3m': 1,
                        'All': 2,
                    };
                
                    const buttonIndex = rangeMap[e.rangeSelectorButton?.text];
                    if (buttonIndex !== undefined) {
                        chart.rangeSelector?.clickButton(buttonIndex, null, true);
                    }
                }
            }
        });
    }
}

Highcharts.Pointer.prototype.reset = function () {
    return null;
};

Highcharts.Point.prototype.highlight = function (event) {
    this.series.chart.tooltip.refresh(this); // Show the tooltip
    this.series.chart.xAxis[0].drawCrosshair(event, this); // Show the crosshair
};

const DraggableCurve = () => {

    useEffect(() => {
        const handleEvent = (e) => {
            let chart, point, i, event;

            for (i = 0; i < Highcharts.charts.length; i = i + 1) {
                chart = Highcharts.charts[i];
                if (chart) {
                    // Find coordinates within the chart
                    event = chart.pointer.normalize(e);
                    // Get the hovered point
                    point = chart.series[0].searchPoint(event, true);

                    if (point) {
                        point.highlight(e);
                    }
                }
            }
        };

        const events = ["mousemove", "touchmove", "touchstart"];
        const element = document.getElementById("draggable-curve");

        if (element) {
            events.forEach((eventType) => {
                element.addEventListener(eventType, handleEvent);
            });
        }

        // Cleanup function to remove event listeners
        return () => {
            if (element) {
                events.forEach((eventType) => {
                    element.removeEventListener(eventType, handleEvent);
                });
            }
        };
    }, [])

    const resetChart = () => {
        const columnChart = Highcharts.charts.find(chart => chart && chart.renderTo.id === 'column-12345');
        const lineChart = Highcharts.charts.find(chart => chart && chart.renderTo.id === 'line-12345');
        if (columnChart && lineChart) {
            COLUMN_CHART_DATA = COLUMN_CHART_DATA_ORIGINAL;
            LINE_CHART_DATA = LINE_CHART_DATA_ORIGINAL;

            lineChartOptions.series[0].data = LINE_CHART_DATA;

            columnChartOptions.series[0].data = COLUMN_CHART_DATA.profit;
            columnChartOptions.series[1].data = COLUMN_CHART_DATA.revenue;

            columnChart.update(columnChartOptions, true);
            lineChart.update(lineChartOptions, true);
        }
    };

    return (
        <div className="flex flex-col gap-4">
            <button className="border-solid border-blue-700 border-2 rounded text-blue-700 w-28 self-end" onClick={resetChart}>Reset Chart</button>
            <div id="draggable-curve">
                <HighchartsReact
                    highcharts={Highcharts}
                    options={lineChartOptions}
                    containerProps={{ id: 'line-12345' }}
                />
                <HighchartsReact
                    highcharts={Highcharts}
                    options={columnChartOptions}
                    containerProps={{ id: 'column-12345' }}
                />
            </div>
        </div>
    );
}

export { DraggableCurve };